const initialState = {
	tasks: [],
};

const tasksReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_TASK':
			return {
				...state,
				tasks: [...state.tasks, action.payload.value],
			};
		case 'REMOVE_TASK':
			return {
				...state,
				tasks: state.tasks.filter(({ id }) => id !== action.payload.value),
			};
		default:
			return state;
	}
};

export const addTaskActionCreator = (task) => ({
	type: 'ADD_TASK',
	payload: {
		value: task,
	},
});

export const removeTaskActionCreator = (id) => ({
	type: 'REMOVE_TASK',
	payload: {
		value: id,
	},
});

export default tasksReducer;
